import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import StartChatInput from 'llm/chat-library/ctas/StartChatInput';

interface AnalyticsDashboardAskInputProps {
  dashboardId: string;
}

export default function AnalyticsDashboardAskInput({
  dashboardId,
}: AnalyticsDashboardAskInputProps): JSX.Element {
  return (
    <StartChatInput
      itemId={dashboardId}
      agentType={BenchlingConfig.LLM_ENABLE_ASSISTANT_AGENT ? AgentType.ASSISTANT : AgentType.ASK}
    />
  );
}
